<template>
  <form
    @submit.prevent="submitReport($event)"
    class="Scroll pl-8 pr-3 pb-3 w-full h-full">
    <h1 class="flex flex-col pb-3 mb-5 border border-gray-400 border-t-0 border-r-0 border-l-0">
      <span class="text-sm text-white font-bold">Laporan Capture Map</span>
      <i class="text-xs text-white">(masukan informasi dari capture map yang dibuat)</i>
    </h1>
    <div class="grid grid-cols-12 grid-rows-auto gap-5 mb-5">
      <div class="col-span-12 md:col-span-6 flex flex-col">
        <h3 class="text-sm text-white mb-3">Form Analisa</h3>
        <div class="w-full">
          <label class="mb-2 text-xs text-gray-300">Nomor</label>
          <input
            v-model="report.nomor"
            class="form-input px-3 py-3 w-full h-8 rounded-md text-xs"
            type="text"
            name="nomor"
            required>
        </div>
        <div class="w-full">
          <label class="mb-2 text-xs text-gray-300">Tanggal</label>
          <div class="relative w-full h-8">
            <input
              v-model="report.tanggal"
              class="px-3 py-3 w-full h-8 rounded-md text-xs"
              type="text"
              name="tanggal"
              required>
            <input
              @change="selectDate($event)"
              class="absolute top-0 right-0 bottom-0 left-0 w-full h-8 rounded-md opacity-0"
              type="datetime-local">
          </div>
        </div>
        <div class="w-full">
          <label class="mb-2 text-xs text-gray-300">Objek</label>
          <input
            v-model="report.objek"
            class="px-3 py-3 w-full h-8 form-input rounded-md text-xs"
            type="text"
            name="objek"
            required>
        </div>
        <div class="w-full">
          <label class="mb-2 text-xs text-gray-300">Status</label>
          <input
            v-model="report.status"
            class="px-3 py-3 w-full h-8 form-input rounded-md text-xs"
            type="text"
            name="status"
            reuqired>
        </div>
        <div class="w-full">
          <label class="mb-2 text-xs text-gray-300">Analisa</label>
          <textarea
            v-model="report.analisa"
            class="px-3 py-3 w-full h-24 form-input rounded-md text-xs"
            type="text"
            name="analisa"
            placeholder="masukan informasi analisa ..."
            reuqired></textarea>
        </div>
      </div>
      <div class="col-span-12 md:col-span-6 flex flex-col">
        <h3 class="text-sm text-white mb-3">Yang Bersangkutan</h3>
        <div class="w-full">
          <label class="mb-2 text-xs text-gray-300">Analis</label>
          <input
            v-model="report.analis"
            class="form-input px-3 py-3 w-full h-8 rounded-md text-xs"
            type="text"
            name="analis"
            required>
        </div>
        <div class="w-full">
          <label class="mb-2 text-xs text-gray-300">Verifikator</label>
          <input
            v-model="report.verifikator"
            class="px-3 py-3 w-full h-8 form-input rounded-md text-xs"
            type="text"
            name="verifikator"
            required>
        </div>
        <div class="w-full">
          <label class="mb-2 text-xs text-gray-300">Mengetahui</label>
          <input
            v-model="report.mengetahui"
            class="px-3 py-3 w-full h-8 form-input rounded-md text-xs"
            type="text"
            name="mengetahui"
            required>
        </div>
      </div>
    </div>
    <div class="flex justify-end items-center gap-1 pt-3 border border-gray-400 border-r-0 border-b-0 border-l-0">
      <button
        @click="setActiveSubMenu('ToolCaptureShoot')"
        class="px-1 py-1 w-32 h-8 bg-gray-400 rounded-md"
        type="button">
        <span class="text-xs text-white">Kembali</span>
      </button>
      <button
        class="px-1 py-1 w-32 h-8 bg-green-500 rounded-md"
        type="submit">
        <span class="text-xs text-white">Simpan</span>
      </button>
    </div>
    <PopupMessage :message="message" />
  </form>

</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import libs from '../libs'
import PopupMessage from './PopupMessage.vue'

export default {
  name: 'ToolCaptureScreenshot',
  computed: {
    ...mapGetters([
      'message',
      'capture',
      'report'
    ])
  },
  components: {
    PopupMessage
  },
  methods: {
    ...mapActions([
      'toShowLargeMenu',
      'toAddReport'
    ]),
    ...mapMutations([
      'setMessage',
      'resetReport',
      'setReport'
    ]),
    ...mapMutations(['setActiveSubMenu']),
    selectDate: function (e) {
      const currentTime = libs.utcFormat(e.target.value, 'object')

      this.setReport({
        tanggal: currentTime.datetime
      })
    },
    submitReport: async function (e) {
      if (this.capture.a === null ||
        this.capture.b === null) {
        this.setMessage({
          text: 'silahkan capture map terlebih dahulu',
          status: 400
        })

        return
      }

      const reportData = new FormData(e.target)

      reportData.append('capture_a', libs.dataURLtoBlob(this.capture.a))
      reportData.append('capture_b', libs.dataURLtoBlob(this.capture.b))

      await this.toAddReport(reportData)

      if (this.message.status === 200) {
        this.setActiveSubMenu('Tool')
        this.resetReport()
      }
    }
  },
  mounted: function () {
    this.toShowLargeMenu()

    let currentTime = new Date()

    currentTime.setTime(currentTime.getTime() + (1000 * 60 * 60))

    currentTime = currentTime.toLocaleString('en-CA', { hourCycle: 'h23'})

    this.setReport({
      tanggal: currentTime
    })
  }
}
</script>

<style scoped>
input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}
</style>
